import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IFooterLinksColumnProps } from '../components/footer/footer-links-column/footer-links-column';
import { IFooterProps } from '../components/footer/footer';
import { FooterLinksColumnModel } from './footer-links-column-model';
import { IFooterExtrasProps } from '../components/footer/footer-extras/footer-extras';
import { FooterExtrasModel } from './footer-extras-model';
import { IItemsInRowComponentProps } from '../components/items-in-row/items-in-row';
import { ItemsInRowModel } from './items-in-row-model';
export class FooterModel extends ContentItem {
  get linkColumns(): IFooterLinksColumnProps[] {
    const linkColumns = get(
      this._config,
      'value[0].elements.link_columns.value',
      []
    );

    const modeledLinkColumns = linkColumns.map((column: IFooterLinksColumn) =>
      FooterLinksColumnModel.create(column)
    );
    return modeledLinkColumns;
  }

  get footerExtras(): IFooterExtrasProps {
    const footerExtras = get(
      this._config,
      'value[0].elements.extras.value[0]',
      ''
    );

    const modeledFooterExtras = FooterExtrasModel.create(footerExtras);

    return modeledFooterExtras;
  }

  get type(): string {
    return get(this._config, 'value[0].elements.type.value[0].codename', '');
  }

  get bottomText(): string {
    return get(this._config, 'value[0].elements.footer_bottom_text.value', '');
  }

  get awards(): IItemsInRowComponentProps {
    const getAwards = get(
      this._config,
      'value[0].elements.awards.value[0]',
      null
    );

    return ItemsInRowModel.create(getAwards);
  }

  public static create(data: IFooter): IFooterProps {
    const {
      linkColumns,
      bottomText,
      footerExtras,
      type,
      awards
    } = new FooterModel(data);

    return {
      linkColumns,
      bottomText,
      footerExtras,
      type,
      awards
    };
  }
}
